exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".horizontalOpts-256fde95{margin:20px 0px 20px 0px}\n", ""]);

// Exports
exports.locals = {
	"horizontalOpts": "horizontalOpts-256fde95"
};